import { WidgetWeatherCondition } from "./__generated__/WidgetWeatherConditionIcon_WeatherOccasion.graphql";

export function getImagesFromCondition(
  condition: WidgetWeatherCondition,
  isNight: boolean
) {
  switch (condition) {
    case "CLEAR_SKY":
      return {
        background: isNight
          ? require("./backgrounds/clear_night.png")
          : require("./backgrounds/clear_sky.png"),
        icon: require("./icons/clear_sky.png"),
      };
    case "FEW_CLOUDS":
      return {
        background: isNight
          ? require("./backgrounds/few_clouds_night.png")
          : require("./backgrounds/few_clouds.png"),
        icon: require("./icons/few_clouds.png"),
      };
    case "SCATTERED_CLOUDS":
      return {
        background: require("./backgrounds/scattered_clouds.png"),
        icon: require("./icons/scattered_clouds.png"),
      };
    case "BROKEN_CLOUDS":
      return {
        background: require("./backgrounds/broken_clouds.png"),
        icon: require("./icons/broken_clouds.png"),
      };
    case "SHOWER_RAIN":
      return {
        background: require("./backgrounds/rain.png"),
        icon: require("./icons/shower_rain.png"),
      };
    case "RAIN":
      return {
        background: require("./backgrounds/rain.png"),
        icon: require("./icons/rain.png"),
      };
    case "THUNDERSTORM":
      return {
        background: require("./backgrounds/thunderstorm.png"),
        icon: require("./icons/thunderstorm.png"),
      };
    case "SNOW":
      return {
        background: require("./backgrounds/snow.png"),
        icon: require("./icons/snow.png"),
      };
    case "MIST":
      return {
        background: require("./backgrounds/mist.png"),
        icon: require("./icons/mist.png"),
      };
    default:
      return {
        background: isNight
          ? require("./backgrounds/clear_sky_n.png")
          : require("./backgrounds/clear_sky.png"),
        icon: require("./icons/clear_sky.png"),
      };
  }
}
